import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {changeModalVisibility} from '../../../../../setup/slices/ModalSlice'
import {client} from '../../../../ApolloClient/client'
import {getActivityCallHistory} from '../../../../helper/ActivityHelper'

interface Props {
  emptyActivity: any
  setFormValues: any
  composeActivity: any
  setCallHistory: any
  typeGuid: string
  selectedDebt: any
  customer: any
  sms: string
  email: string
}

const InstantPayment: React.FC<Props> = ({
  emptyActivity,
  setFormValues,
  composeActivity,
  setCallHistory,
  typeGuid,
  selectedDebt,
  customer,
  sms,
  email,
}) => {
  const [paymentAmount, setPaymentAmount] = useState<any>()
  const [contactOption, setContactOption] = useState<string>('')
  const [contactValue, setContactValue] = useState<string>('')
  const [expText, setExpText] = useState<any>()
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)
  const [contactText, setContactText] = useState<string>('')

  const dispatch = useDispatch()

  useEffect(() => {
    setFormValues([
      contactOption,
      expText,
      '',
      emptyActivity.activityStatements[4].jsonValues.items[0].option,
      paymentAmount,
      '',
      '',
      contactValue,
    ])
  }, [paymentAmount, contactOption, expText, contactValue])

  useEffect(() => {
    setFormValues([])
  }, [])

  useEffect(() => {
    setContactValue(contactText)
  }, [contactText])

  useEffect(() => {
    setPaymentAmount(selectedDebt)
  }, [selectedDebt])

  const handleSubmit = (event: any) => {
    event.preventDefault()
    setButtonDisabled(true)
    composeActivity(customer)
    getActivityCallHistory(5, typeGuid, client, setCallHistory, customer.CustomerId)

    setTimeout(() => {
      dispatch(changeModalVisibility(false))
      setButtonDisabled(false)
    }, 1000)
  }

  return (
    <form className='row d-flex ms-10' onSubmit={(event) => handleSubmit(event)}>
      <div className='row w-70'>
        <div className='col-md-1'></div>
        <label
          className='col-md-4 fw-bolder fs-6 '
          style={{alignSelf: 'center'}}
          htmlFor='paymentAmount'
        >
          {emptyActivity.activityStatements[5].statementText}
        </label>
        <div className='col-md-5 '>
          <input
            type='number'
            className='form-control text-end text-success fw-bolder'
            id='paymentAmount'
            value={parseFloat(paymentAmount).toFixed(2)}
            onChange={(e) => setPaymentAmount(e.target.value)}
            required
          />
        </div>
      </div>
      <div className='row mt-6 '>
        <div className='col-md-1'></div>
        <label className='col-md-4 fw-bolder fs-6 ' style={{alignSelf: 'center'}}>
          {emptyActivity.activityStatements[1].statementText}:
        </label>
        <div className='col-md-6 '>
          <div className='col-md-10'>
            <div className='col-md-12 d-flex flex-row justfiy-content-evenly'>
              {emptyActivity.activityStatements[1].jsonValues.items.map(
                (element: any, index: number) => (
                  <div key={index} className='form-check col-md-4'>
                    <input
                      className='form-check-input col-md-6'
                      type='radio'
                      name='contactInfo'
                      id={`contactInfo-${index}`}
                      value={element.option}
                      onChange={(e) => {
                        setContactOption(e.target.value)
                        setContactText(element.option === 'Sms' ? sms.slice(3) : email)
                      }}
                      required
                    />
                    <label className='form-check-label' htmlFor={`contactInfo-${index}`}>
                      {element.option}
                    </label>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='row mt-6 '>
        <div className='col-md-1'></div>
        <label className='col-md-4 fw-bolder fs-6 ' style={{alignSelf: 'center'}}>
          {emptyActivity.activityStatements[8].statementText}:
        </label>
        <div className='col-md-6 '>
          <div className='col-md-10 mt-1'>
            <input
              type='text'
              className='form-control col-12'
              id='contactInfoInput'
              defaultValue={contactText}
              onChange={(e) => setContactValue(e.target.value)}
              required
            />
          </div>
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-md-1'></div>
        <label
          className='col-md-4 fw-bolder fs-6 '
          style={{alignSelf: 'center'}}
          htmlFor='explanationText'
        >
          {emptyActivity.activityStatements[2].statementText}:
        </label>
        <div className='col-md-5 '>
          <textarea
            className='form-control'
            id='explanationText'
            rows={4}
            onChange={(e) => setExpText(e.target.value)}
          ></textarea>
        </div>
      </div>
      <div className='col-md-8 d-flex justify-content-end mt-4 me-4'>
        <div className='w-80'>
          <button type='submit' className='btn btn-success w-100' disabled={buttonDisabled}>
            Kaydet
          </button>
        </div>
      </div>
    </form>
  )
}

export default InstantPayment
